type MediaPlaybackOptions = {
  onError?: (_error: unknown) => void
}

export const isAbortPlaybackError = (error: unknown): boolean => {
  return error instanceof DOMException && error.name === 'AbortError'
}

export const playMediaSafely = async (
  media: HTMLMediaElement | null,
  options?: MediaPlaybackOptions,
): Promise<boolean> => {
  if (!media) {
    return false
  }

  try {
    await media.play()
    return true
  } catch (error) {
    if (!isAbortPlaybackError(error)) {
      options?.onError?.(error)
    }

    return false
  }
}

export const pauseMediaSafely = (media: HTMLMediaElement | null): void => {
  if (!media) {
    return
  }

  media.pause()
}
